import { Text, useDisclosure, useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, ViewContainer } from "components";
import { useNavigate } from "react-router";
import { isCustomApiError } from "types";
import { appErrors, useScreen } from "utils";
import { UserForm } from "../../components";
import { UsersScreenDefinition } from "../Users";
import { createUser } from "../Users.requets";
import { CreateUserScreenDefinition } from "./CreateUser.definition";

const CreateUser = () => {
  useScreen(CreateUserScreenDefinition);
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const toast = useToast();

  const { mutate, isLoading } = useMutation(createUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(["listUsers"]);
      onOpen();
    },
    onError: (err) => {
      if (isCustomApiError(err)) {
        toast({
          title:
            err.response.internalCode === "409UserAlreadyExists"
              ? appErrors["409UserAlreadyExists"]
              : appErrors["SomethingWentWrong"],
          status: "warning",
        });
      }
    },
  });

  return (
    <>
      <ViewContainer>
        <UserForm
          isLoading={isLoading}
          onSubmit={mutate}
          submitLabel="Create"
        />
      </ViewContainer>

      <Modal
        title="User has been created"
        body={
          <Text>
            We will send a confirmation email with a link for creating password
            on the address provided in the form.
          </Text>
        }
        primaryButton={
          <Button
            aria-label="Close"
            onClick={() => {
              onClose();
              navigate(UsersScreenDefinition.navigate());
            }}
          >
            Close
          </Button>
        }
        isOpen={isOpen}
        onClose={() => {
          onClose();
          navigate(UsersScreenDefinition.navigate());
        }}
      />
    </>
  );
};

export { CreateUser };
